import Ajv2020 from 'ajv/dist/2020';

/**
 * Single source of AJV configuration for the sample generator. Mirrors the
 * configuration used by ValidationPreview so generated payloads are verified
 * with identical semantics to the Validate button.
 *
 * @returns {import('ajv/dist/2020').default} a fresh AJV 2020 instance
 */
export function createAjv() {
  return new Ajv2020({ allErrors: true, strict: false });
}
